export const REAFFIRM_DATE_THRESHOLD_MONTHS = 6;
export const ACCESS_CONTROL_DATE_THRESHOLD_MONTHS = 6;
